<template>
    <div class="breadcrumbs baron headerText">
        <slot></slot>
    </div>
</template>

<script lang="ts" setup>
</script>

<style lang="scss" scoped>
.breadcrumbs {
    display: flex;
    gap: 8px;

    &:deep(a) {
        display: block;
        text-decoration: none;
        color: var(--color-primary);
        text-wrap: nowrap;

        &:after {
            content: '/';
            margin: 0 0 0 8px;
        }

        &:last-of-type:after {
            display: none;
        }
    }
}
</style>